import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import Home from '@/views/Home.vue';
import Download from '@/views/Download.vue';

import store from '@/store';
import { authGuard } from '@/services/auth0/authGuard';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/download/:app/:version/:type',
    name: 'Download',
    beforeEnter: authGuard,
    component: Download,
  },
  {
    path: '/app/:slug',
    name: 'AppRoute',
    beforeEnter: authGuard,
    component: () => import('@/views/AppRoute.vue'),
  },
  {
    path: '*',
    component: () => import('@/views/NotFoundRoute.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((_to, _from, next) => {
  store.commit('http/cancelPendingRequests');
  next();
});

export default router;
